module.exports = __webpack_public_path__ + "img/emotion-germany.391d103.webp";